import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useToasts } from "react-toast-notifications";
import { detailNotification, resetDetailNotification } from "store/actions";
import {
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import { notificationModeList } from "./utils";
import { Controller, useForm } from "react-hook-form";

const DetailNotification = props => {
  const { isOpenModal, dataDetail, toggleModal, mode, refreshNotification } =
    props;

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["notificationManagement"]);
  const { addToast } = useToasts();

  const notificationManagement = useSelector(
    state => state.notificationManagement
  );
  const {
    loadingDetail,
    errorDetail,
    detail: notificationDetail,
  } = notificationManagement;

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    // resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      code: "",
      description: "",
    },
  });

  useEffect(() => {
    if (!isOpenModal) {
      dispatch(resetDetailNotification());
      setIsDetail(false);
      refreshNotification(mode);
    }
  }, [dispatch, isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && dataDetail.notificationId && !isDetail) {
        dispatch(detailNotification(dataDetail.notificationId));
      }
    }
  }, [dataDetail, dispatch, isDetail, isOpenModal]);

  // Set Data Detail
  useEffect(() => {
    if (isOpenModal) {
      if (notificationDetail && notificationDetail.success && !isDetail) {
        reset({
          code: "",
          description: notificationDetail.description
            ? notificationDetail.description
            : "",
        });
        setValue("code", notificationDetail.code);
        setIsDetail(true);
      }
    }
  }, [isDetail, isOpenModal, notificationDetail, reset, setValue]);

  // Error Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (errorDetail && errorDetail.message) {
        addToast(errorDetail.message, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDetailNotification());
      }
    }
  }, [addToast, dispatch, errorDetail, isOpenModal]);

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {mode === notificationModeList.VIEW_NOTIFICATION_DETAIL &&
              `${t("title.detail")}`}
          </ModalHeader>
          {loadingDetail ? (
            <ModalBody>
              <LoadingFormNormal
                countInput="4"
                countButton="0"
                formClass="row-cols-1"
                buttonClass="justify-content-end"
                buttonColClass="col-3"
              />
            </ModalBody>
          ) : (
            <React.Fragment>
              <ModalBody>
                <Row className="row-cols-1">
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="code">Mã thông báo</Label>
                      <input
                        type="text"
                        className="form-control"
                        readOnly
                        {...register("code")}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="description">Chi tiết</Label>
                      <Controller
                        control={control}
                        name="description"
                        render={({ field }) => <div>{field.value}</div>}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
            </React.Fragment>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

DetailNotification.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  refreshNotification: PropTypes.func.isRequired,
};

DetailNotification.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
};

export default DetailNotification;
